import {useState, useEffect} from 'react';
import ListIntentComponent from '../../components/ListIntentComponent';
import IntentDetailComponent from '../../components/IntentDetailComponent';


const IntentsPage = () => {

  return (
    <div className="container" >

      <ListIntentComponent />
    </div>
  )
}

export default IntentsPage;
